import {Component, NgZone, OnDestroy, OnInit} from '@angular/core';
import {InactivityTime} from '../../global/util/InactivityTime';
import {Session} from '../../global/util/enum/Session';
import {LocalStorage} from '../../global/util/LocalStorage';
import {AuthService} from '../../user/service/auth/auth.service';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-session-inactivity',
  templateUrl: './session-inactivity.component.html',
  styleUrls: ['./session-inactivity.component.css']
})
export class SessionInactivityComponent implements OnInit, OnDestroy {
  minutes = InactivityTime.MINUTES;
  seconds = InactivityTime.SECONDS;
  milliseconds = InactivityTime.MILLISECONDS;
  minutesLeft = InactivityTime.MINUTES;
  secondsLeft = InactivityTime.SECONDS;
  interval: any;
  message = '';

  constructor(private ngZone: NgZone,
              private authentication: AuthService,
              public activeModal: NgbActiveModal,
              private translateService: TranslateService) {
    this.initInterval();
    LocalStorage.setSessionDuration(Date.now());
    this.message = this.translateService.instant('MESSAGE.YOU-WILL-BE-LOGGED-OUT-FOR-TOO-MUCH-IDLE-TIME');
  }

  ngOnInit(): void {
  }

  /*Interval timer countdown to logout session*/
  initInterval() {
    this.interval = setInterval(() => {
      const now = Date.now();
      // tslint:disable-next-line:radix
      const differenceTime = (parseInt(LocalStorage.getLastSessionDuration()) + (this.minutes) * this.seconds * this.milliseconds);
      const isTimeout = (differenceTime - now) < 0;
      this.minutesLeft = this.getMinutesLeft(now, differenceTime, this.seconds, this.milliseconds);
      this.secondsLeft = this.getSecondsLeft(now, differenceTime, this.seconds, this.milliseconds);
      this.ngZone.run(() => {
        if (isTimeout && this.authentication.isAuthenticated()) {
          LocalStorage.removeSessionDuration();
          this.activeModal.close(Session.LOGOUT);
        }
      });
    }, 1000);
  }

  /*Obtenemos el minuto restante cuando el usuarios no realiza ninguna acción en la plataforma.*/
  getMinutesLeft(now: number, differenceTime: number, seconds: number, milliseconds: number) {
    return Math.floor(((differenceTime - now) % (milliseconds * seconds * seconds)) / (milliseconds * seconds));
  }

  /*Obtenemos el segundo restante cuando el usuarios no realiza ninguna acción en la plataforma.*/
  getSecondsLeft(now: number, differenceTime: number, seconds: number, milliseconds: number) {
    return Math.floor(((differenceTime - now) % (milliseconds * seconds)) / milliseconds);
  }

  accept() {
    this.activeModal.close(Session.LOGOUT);
  }

  keepSession() {
    this.activeModal.close(Session.KEEP);
  }

  ngOnDestroy(): void {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

}
